import React from "react";
import { Outlet } from "react-router-dom";
import { AppSidebarUser } from "../../components/Common/appSidebarUser";
import { SidebarProvider } from "../../components/ui/sidebar";
import { useLanguage } from "../../context/LanguageContext";
import UserHeader from "./UserHeader";

export default function UserRoot() {
  const { language } = useLanguage();

  return (
    <SidebarProvider>
      {language !== "ar" && <AppSidebarUser />}
      <main className="w-full">
        <UserHeader />
        <div className="p-5">
          <Outlet />
        </div>
      </main>
      {language === "ar" && <AppSidebarUser />}
    </SidebarProvider>
  );
}
